import React from 'react';
import { Input as AntInput, InputProps } from 'antd';

import { PassInVisibleIcon, PassVisibleIcon } from '~shared/ui/Icons/icons';
import { PlaceholderAsLabel } from '~shared/ui/layout';

export const Input: React.FC<InputProps> = ({
  type,
  size = 'large',
  placeholder,
  value,
  ...props
}) => {
  switch (type) {
    case 'password':
      return (
        <PlaceholderAsLabel placeholder={placeholder} value={value}>
          <AntInput.Password
            type={type}
            size={size}
            value={value}
            placeholder={placeholder}
            {...props}
            iconRender={(visible) => (visible ? PassVisibleIcon() : PassInVisibleIcon())}
          />
        </PlaceholderAsLabel>
      );
    default:
      return (
        <PlaceholderAsLabel placeholder={placeholder} value={value}>
          <AntInput type={type} size={size} {...props} value={value} placeholder={placeholder} />
        </PlaceholderAsLabel>
      );
  }
};
